import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import { CommunicationService } from './communication.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls:  ['./app.component.css']
})
export class AppComponent {

   defaultMessage = 'SoftwareDue App v.1.0';
   title = '';
   loggedUser: string;
   cookieMessage: string = "Questo sito utilizza cookie, per fornirti la miglior esperienza di navigazione possibile"
   cookieDismiss: string = "No Problem"
   cookieLinkText: string = "Learn More"

   constructor(
      public auth: AuthService,
      private communication: CommunicationService,
      public router: Router
   ) {}

   ngOnInit() {
    let cc = window as any;
    cc.cookieconsent.initialise({
      palette: {
        popup: {
          background: "#164969"
        },
        button: {
          background: "#ffe000",
          text: "#164969"
        }
      },
      theme: "classic",
      content: {
        message: this.cookieMessage,
        dismiss: this.cookieDismiss,
        link: this.cookieLinkText,
        //href: environment.Frontend + "/dataprivacy"
      }
    });
      // alert("AppComponent: \n ngOnInit called...");   // DEBUG
      // call the AuthService isAuthenticated method, that returns an Observable<boolean>
      // and will set the state (isLoggedIn) of AuthService
      // to a value reflecting the presence/absence of a logged user
      this.auth.isAuthenticated().subscribe(
         obs => {
            // alert("isAuthenticated returned: " + obs);
         },
         error => {
            alert("isAuthenticated error!");
         }
      );

      // subscribe to the auth.isLoggedIn BehaviorSubject
      this.auth.isLoggedIn.subscribe( value => {
         // alert("value = " + value);    // DEBUG
         // and when notified of its setting
         if ( value === true ) {                             // if the new value is true
            // call the AuthService getUserInfo method – that returns an Observable<any>
            // of shape: { "id": string, "username": string, "attributes": object } –
            this.auth.getUserInfo().subscribe(              // and on success
               // set the loggedUser prop to the value of the family_name attribute
               data => {
                  const familyName = data.attributes.family_name;
                  this.loggedUser = familyName;   // to be displayed by the template
            },
            error => {
               // note: this should never happen
               alert("AppComponent: getUserInfo error!");
               console.log("AppComponent: getUserInfo error = " + JSON.stringify(error, null, 2));
            });
         }  else {
            // set the loggedUser prop to "" so to display nothing in the template
            this.loggedUser = "";
         }  // end if
      });

      this.communication.currentMessage.subscribe(
        message => {
          if(message !== "") {
            this.title = message;
          } else {
            this.title = this.defaultMessage;
          }
        }
      );

   }  // end ngOnInit

   ngOnDestroy() {
   }

   onClickLogout() {

      // alert("LOGGING OUT...");     // DEBUG

      // call the AuthService logout method, that returns an Observable<any>
      this.auth.logout().subscribe(
         data => {
            // alert("YOU SUCCESSFULLY LOGGED OUT");
            console.log("Successful signOut");
            this.communication.setMessage("");      // reset title
            this.router.navigate(['/login']);       // go to the login page/component
         },
         error => {
            alert("LOGOUT ERROR");
            console.log("Failed signOut: error = " + JSON.stringify(error, null, 2));
         }
      );

   }  // end onClickLogout

   onClickNavigateChange(){
     this.router.navigate(['/changePassword']);
   }

}  // end AppComponent
